export enum SearchableFieldType {
  Text = 'text',
  Number = 'number',
  Date = 'date',
  /**
   * @deprecated Utilizzare Radio con valori booleani
   */
  Switch = 'switch',
  DateRange = 'dateRange',
  NumberRange = 'numberRange',
  Select = 'select',
  Radio = 'radio',
  // DateTime = 'datetime',
  // Boolean = 'boolean',
  Custom = 'custom',
}

export enum SearchableFieldGroup {
  Filters = 'Filtri',
  SemanticTags = 'Tag Semantici',
}

interface BaseSearchableField {
  type: SearchableFieldType;
  /** Codice univoco per la selezione */
  name: string;
  /** Nome che appare nell'Elenco */
  label: string;
  /** Nasconde questo campo dalla ricerca */
  hidden?: boolean;
  /** Permette di raggruppare i filtri nel dropdown di selezione */
  group: SearchableFieldGroup;
}

/**
 * Dati per la ricerca di un campo "semplice"
 */
export interface SearchableFieldPlain extends BaseSearchableField {
  placeholder?: string;
  type:
    | SearchableFieldType.Text
    | SearchableFieldType.Number
    | SearchableFieldType.Date
    | SearchableFieldType.Switch;
}

export const PlainSearchableField = [
  SearchableFieldType.Text,
  SearchableFieldType.Number,
  SearchableFieldType.Date,
  SearchableFieldType.Switch,
];

export function isPlainSearchableField(
  fieldType: SearchableFieldType,
): fieldType is SearchableFieldPlain['type'] {
  return PlainSearchableField.includes(fieldType);
}

export interface SearchableFieldRange extends BaseSearchableField {
  type: SearchableFieldType.DateRange | SearchableFieldType.NumberRange;
  from: {
    name: string;
    label: string;
    placeholder?: string;
  };
  to: {
    name: string;
    label: string;
    placeholder?: string;
  };
}

export interface SearchableFieldCustom extends BaseSearchableField {
  type: SearchableFieldType.Custom;
  input: React.ReactNode;
  /**
   * Override del rendering del valore quando il chip è chiuso nella FilterBar.
   * Se omesso, viene usato un fallback automatico (array → "N selezionati",
   * boolean → "Sì/No", number/string → valore).
   */
  renderValue?: (value: unknown) => React.ReactNode;
}

export type SearchableField =
  | SearchableFieldPlain
  | SearchableFieldRange
  | SearchableFieldSelect
  | SearchableFieldCustom;

/**
 * Configurazione della riga di ricerca
 */
export interface SearchableFieldRow {
  id: string;
  name: string | null;
}

export const RangeSearchableField = [
  SearchableFieldType.DateRange,
  SearchableFieldType.NumberRange,
];

export function isRangeSearchableFieldType(
  fieldType: SearchableFieldType,
): fieldType is SearchableFieldRange['type'] {
  return RangeSearchableField.includes(fieldType);
}

export function isRangeSearchableField(
  field: SearchableField,
): field is SearchableFieldRange {
  return RangeSearchableField.includes(field.type);
}

export interface SearchableFieldSelect extends BaseSearchableField {
  type: SearchableFieldType.Select | SearchableFieldType.Radio;
  options: Array<{ value: string | boolean | number; label: React.ReactNode }>;
  placeholder?: string;
}
